export const STORE_ALL_ATTRIBUTES = 'ATTRIBUTES:STORE_ALL';
